export interface PlanLink {
  label: string;
  url: string;
}

export interface Plan {
  id: number;
  brand: 'TOTO' | 'LIXIL' | 'オプション';
  name: string;
  model: string;
  grade: 'スタンダード' | 'アドバンス' | 'プレミアム' | 'オプション';
  price: number;
  features: string[];
  image: string;
  popular?: boolean;
  badge?: string;
  links?: PlanLink[];
}

export const plans: Plan[] = [
  {
    id: 1,
    brand: 'LIXIL',
    name: 'アメージュ+シャワートイレ KB',
    model: 'LIXIL アメージュ+シャワートイレKB',
    grade: 'スタンダード',
    price: 150000,
    features: ['アクアセラミック', '強力洗浄の超節水', '使いやすいシンプル機能'],
    image: 'https://public.readdy.ai/ai/img_res/2579e4de94cfda3c6833dac5d7a42caf.jpg',
    links: [
      { label: 'アメージュ便器の特徴', url: 'https://www.lixil.co.jp/lineup/toiletroom/amage_z/feature/' },
      { label: 'シャワートイレKBの特徴', url: 'https://www.lixil.co.jp/lineup/toiletroom/ka_kb/' },
    ],
  },
  {
    id: 2,
    brand: 'LIXIL',
    name: 'アメージュ+シャワートイレ KA',
    model: 'LIXIL アメージュ+シャワートイレKA',
    grade: 'アドバンス',
    price: 170000,
    features: ['アクアセラミック', 'フルオート便器洗浄', 'すっきり壁リモコン'],
    image: 'https://readdy.ai/api/search-image?query=LIXIL%20advanced%20combination%20toilet%20white%20tank%20bowl%20washlet%20bidet%20seat%20auto%20flush%20Japanese%20toilet%20set%20product%20photography%20pure%20white%20background%20studio%20lighting%20professional%20clean%20full%20assembly%20combination%20unit%20no%20text%20no%20logo&width=400&height=400&seq=402&orientation=squarish',
    popular: true,
    badge: '人気No.1',
    links: [
      { label: 'アメージュ便器の特徴', url: 'https://www.lixil.co.jp/lineup/toiletroom/amage_z/feature/' },
      { label: 'シャワートイレKAの特徴', url: 'https://www.lixil.co.jp/lineup/toiletroom/ka_kb/' },
    ],
  },
  {
    id: 3,
    brand: 'LIXIL',
    name: 'アメージュ+シャワートイレ New PASSO',
    model: 'LIXIL アメージュ+シャワートイレNew PASSO',
    grade: 'プレミアム',
    price: 200000,
    features: ['アクアセラミック', 'フルオート機能（便座・洗浄）', 'ノズル除菌・鉢内スプレー'],
    image: 'https://readdy.ai/api/search-image?query=LIXIL%20advanced%20combination%20toilet%20white%20tank%20bowl%20washlet%20bidet%20seat%20auto%20flush%20Japanese%20toilet%20set%20product%20photography%20pure%20white%20background%20studio%20lighting%20professional%20clean%20full%20assembly%20combination%20unit%20no%20text%20no%20logo&width=400&height=400&seq=402&orientation=squarish',
    badge: 'PREMIUM',
    links: [
      { label: 'アメージュ便器の特徴', url: 'https://www.lixil.co.jp/lineup/toiletroom/amage_z/feature/' },
      { label: 'New PASSO の特徴', url: 'https://www.lixil.co.jp/lineup/toiletroom/passo/' },
    ],
  },
  {
    id: 4,
    brand: 'TOTO',
    name: 'ピュアレストQR+ウォシュレットSS1',
    model: 'TOTO ピュアレストQR+ウォシュレットSS1',
    grade: 'スタンダード',
    price: 160000,
    features: ['セフィオンテクト', 'きれい除菌水', '使いやすいシンプル機能'],
    image: 'https://readdy.ai/api/search-image?query=TOTO%20PureRest%20advanced%20combination%20toilet%20white%20tank%20bowl%20washlet%20auto%20flush%20bidet%20seat%20assembled%20Japanese%20combination%20toilet%20full%20set%20front%20view%20product%20photography%20pure%20white%20background%20studio%20lighting%20professional%20clean%20no%20text%20no%20logo&width=400&height=400&seq=405&orientation=squarish',
    links: [
      { label: 'ピュアレストQRカタログ', url: 'https://www.catalabo.org/iportal/CatalogViewInterfaceStartUpAction.do?method=startUp&mode=PAGE&volumeID=CATALABO&catalogId=84802640000&pageGroupId=&designID=link&catalogCategoryId=&designConfirmFlg=' },
      { label: 'ウォシュレットSS1の特徴', url: 'https://jp.toto.com/products/toilet/s/' },
    ],
  },
  {
    id: 5,
    brand: 'TOTO',
    name: 'ピュアレストQR+ウォシュレットSS2A',
    model: 'TOTO ピュアレストQR+ウォシュレットSS2A',
    grade: 'アドバンス',
    price: 180000,
    features: ['セフィオンテクト', 'フルオート便器洗浄', 'すっきり壁リモコン'],
    image: 'https://readdy.ai/api/search-image?query=TOTO%20PureRest%20advanced%20combination%20toilet%20white%20tank%20bowl%20washlet%20auto%20flush%20bidet%20seat%20assembled%20Japanese%20combination%20toilet%20full%20set%20front%20view%20product%20photography%20pure%20white%20background%20studio%20lighting%20professional%20clean%20no%20text%20no%20logo&width=400&height=400&seq=405&orientation=squarish',
    links: [
      { label: 'ピュアレストQRカタログ', url: 'https://www.catalabo.org/iportal/CatalogViewInterfaceStartUpAction.do?method=startUp&mode=PAGE&volumeID=CATALABO&catalogId=84802640000&pageGroupId=&designID=link&catalogCategoryId=&designConfirmFlg=' },
      { label: 'ウォシュレットSS2Aの特徴', url: 'https://jp.toto.com/products/toilet/s/' },
    ],
  },
  {
    id: 6,
    brand: 'TOTO',
    name: 'ピュアレストQR+アプリコットF3A',
    model: 'TOTO ピュアレストQR+アプリコットF3A',
    grade: 'プレミアム',
    price: 210000,
    features: ['セフィオンテクト', 'フルオート機能（便座・洗浄）', '使うたび除菌'],
    image: 'https://readdy.ai/api/search-image?query=TOTO%20PureRest%20advanced%20combination%20toilet%20white%20tank%20bowl%20washlet%20auto%20flush%20bidet%20seat%20assembled%20Japanese%20combination%20toilet%20full%20set%20front%20view%20product%20photography%20pure%20white%20background%20studio%20lighting%20professional%20clean%20no%20text%20no%20logo&width=400&height=400&seq=405&orientation=squarish',
    badge: 'PREMIUM',
    links: [
      { label: 'ピュアレストQRカタログ', url: 'https://www.catalabo.org/iportal/CatalogViewInterfaceStartUpAction.do?method=startUp&mode=PAGE&volumeID=CATALABO&catalogId=84802640000&pageGroupId=&designID=link&catalogCategoryId=&designConfirmFlg=' },
      { label: 'アプリコットF3A の特徴', url: 'https://jp.toto.com/products/toilet/apricot/' },
    ],
  },
  {
    id: 7,
    brand: 'オプション',
    name: '内装パック工事',
    model: '壁紙・床CF貼替',
    grade: 'オプション',
    price: 50000,
    features: ['壁紙貼替（天井・壁）', '床CF貼替'],
    image: 'https://readdy.ai/api/search-image?query=clean%20bright%20renovated%20toilet%20room%20interior%20fresh%20white%20wallpaper%20clean%20vinyl%20floor%20professional%20renovation%20result%20bright%20light%20modern%20minimal%20japanese%20bathroom%20interior%20no%20text&width=400&height=400&seq=307&orientation=squarish',
  },
  {
    id: 8,
    brand: 'オプション',
    name: '床補強+内装パック工事',
    model: '床下地補強・壁紙・床CF貼替',
    grade: 'オプション',
    price: 80000,
    features: ['床下地（合板増張り）', '壁紙貼替（天井・壁）', '床CF貼替'],
    image: 'https://readdy.ai/api/search-image?query=toilet%20bathroom%20floor%20reinforcement%20renovation%20clean%20bright%20interior%20professional%20construction%20work%20plywood%20subfloor%20fresh%20new%20clean%20japanese%20toilet%20room%20remodel%20no%20text&width=400&height=400&seq=308&orientation=squarish',
  },
  {
    id: 9,
    brand: 'オプション',
    name: 'アクセサリー交換パック',
    model: '紙巻き器・タオル掛け交換',
    grade: 'オプション',
    price: 10000,
    features: ['棚付き2連紙巻き器', 'タオル掛け'],
    image: 'https://readdy.ai/api/search-image?query=modern%20toilet%20accessories%20chrome%20towel%20bar%20double%20toilet%20paper%20holder%20with%20shelf%20clean%20white%20wall%20bathroom%20accessory%20set%20professional%20product%20photography%20pure%20white%20background%20studio%20minimal%20no%20text&width=400&height=400&seq=309&orientation=squarish',
  },
  {
    id: 10,
    brand: 'オプション',
    name: '電気パック工事',
    model: 'LED照明・コンセント・スイッチ交換',
    grade: 'オプション',
    price: 20000,
    features: ['LED照明', 'コンセント・スイッチ交換'],
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20ceiling%20light%20and%20electrical%20outlet%20switch%20panel%20in%20clean%20white%20bathroom%20toilet%20room%20interior%20professional%20renovation%20bright%20contemporary%20Japanese%20minimal%20no%20text&width=400&height=400&seq=310&orientation=squarish',
  },
  {
    id: 11,
    brand: 'オプション',
    name: '換気扇交換工事',
    model: 'パイプファン交換',
    grade: 'オプション',
    price: 20000,
    features: ['パイプファン'],
    image: 'https://readdy.ai/api/search-image?query=modern%20white%20ventilation%20pipe%20fan%20on%20clean%20white%20bathroom%20ceiling%20professional%20installation%20minimal%20simple%20product%20photography%20pure%20white%20background%20no%20text%20clean&width=400&height=400&seq=311&orientation=squarish',
  },
  {
    id: 12,
    brand: 'オプション',
    name: '安心バリアフリーパック工事',
    model: '段差緩和・手摺新設',
    grade: 'オプション',
    price: 70000,
    features: ['段差緩和', '手摺新設'],
    image: 'https://readdy.ai/api/search-image?query=barrier%20free%20accessible%20toilet%20room%20renovation%20grab%20bar%20safety%20handrail%20clean%20bright%20white%20Japanese%20bathroom%20interior%20elderly%20friendly%20professional%20renovation%20result%20no%20text&width=400&height=400&seq=312&orientation=squarish',
  },
];
